import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import JwPagination from 'jw-react-pagination'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
// import Search from '../../Search'
import {
  Accordion,
  AccordionItem,
  AccordionItemTitle,
  AccordionItemBody,
} from 'react-accessible-accordion'
import './style.css'
import {
  faAngleDoubleLeft,
  faAngleDoubleRight,
  faAngleLeft,
  faAngleRight,
  faCaretRight,
  faCode,
  faFile,
  faFileArchive,
  faFont,
  faHeading,
  faLink,
  faVideo,
} from '@fortawesome/free-solid-svg-icons'
import CustomModal from './CustomModal'
import { ModalBody } from 'reactstrap'
import Search from 'views/pages/Search'

const getFontawesomeIcon = (type) => {
  switch (type) {
    case 0:
      return <FontAwesomeIcon icon={faHeading} />
    case 1:
      return <FontAwesomeIcon icon={faFont} />
    case 2:
      return <FontAwesomeIcon icon={faVideo} />
    case 4:
      return <FontAwesomeIcon icon={faFile} />
    case 5:
      return <FontAwesomeIcon icon={faCode} />
    case 8:
      return <FontAwesomeIcon icon={faFileArchive} />
    case 9:
      return <FontAwesomeIcon icon={faLink} />
    default:
      return ''
  }
}

class AddExistingContent extends Component {
  render() {
    const { props } = this
    let language = props.language || {}

    const customLabels = {
      first: <FontAwesomeIcon icon={faAngleDoubleLeft} />,
      last: <FontAwesomeIcon icon={faAngleDoubleRight} />,
      previous: <FontAwesomeIcon icon={faAngleLeft} />,
      next: <FontAwesomeIcon icon={faAngleRight} />,
    }

    return (
      <CustomModal
        courseId={props.course_id}
        title={language.courses ? language.courses.add_existing_content : null}
        size='xl'
      >
        <ModalBody>
          <div style={{ textAlign: 'center', marginBottom: '10px' }}>
            <JwPagination
              pageSize={20}
              disableDefaultStyles={true}
              items={props.items}
              onChangePage={props.setPaginationPageOfItems}
              labels={customLabels}
            />
          </div>
          <div className='row'>
            <div className='col-9'></div>
            <div className='col-3 mb-2'>
              <Search
                placeholder={
                  language.settings ? language.settings.search_courses : null
                }
                value={props.searchValueExistingContent || ''}
                onChange={(e) =>
                  props.setSearchValueExistingContent(e.target.value)
                }
              />
            </div>
            <div className='col-12'>
              <div className='select-content-accordion'>
                <Accordion>
                  {(() => {
                    return props.pageOfItems.map((course, index) => {
                      let contents = course.contents
                      if (course.id !== props.course_id) {
                        return (
                          <AccordionItem key={index}>
                            <AccordionItemTitle>
                              {course.name.trim()}
                              <FontAwesomeIcon
                                icon={faCaretRight}
                                className=' accordion-icon'
                                style={{ float: 'right' }}
                              />
                            </AccordionItemTitle>
                            <AccordionItemBody>
                              <div className='course-content'>
                                <ul>
                                  {(() => {
                                    if (contents.length) {
                                      return contents.map(
                                        (singleContent, contentIndex) => {
                                          const currentContent = contents.find(
                                            (content) =>
                                              content.id === singleContent.id
                                          )
                                          if (currentContent) {
                                            return (
                                              <li
                                                key={contentIndex}
                                                onClick={() =>
                                                  props.addExistingContent(
                                                    currentContent.id,
                                                    props.language_id
                                                  )
                                                }
                                                className='content-options'
                                              >
                                                <span className='contents-icon'>
                                                  {getFontawesomeIcon(
                                                    singleContent.type
                                                  )}
                                                </span>
                                                <Link
                                                  title={currentContent.title}
                                                  to={`/course/${props.course_id}/edit`}
                                                  className='content-link'
                                                >
                                                  {currentContent.title
                                                    ? currentContent.title.trim()
                                                    : 'No content title'}
                                                </Link>
                                              </li>
                                            )
                                          }
                                          return
                                        }
                                      )
                                    }
                                    return 'No content found'
                                  })()}
                                </ul>
                              </div>
                            </AccordionItemBody>
                          </AccordionItem>
                        )
                      }
                    })
                  })()}
                </Accordion>
              </div>
            </div>
          </div>
        </ModalBody>
      </CustomModal>
    )
  }
}

export default AddExistingContent
